import { createRouter, SCREENS } from './router.js';
import { uploadPhoto } from './upload.js';
import { copy } from './copy.js';

const root = document.getElementById('app');

// Session token is passed in the path (/s/<token>) or ?s=<token>. In mock
// mode it can be absent; we synthesize one so the rest of the flow behaves.
function readSessionToken() {
  if (typeof window === 'undefined') return null;
  const pathMatch = window.location.pathname.match(/\/s\/([A-Za-z0-9_-]+)/);
  if (pathMatch) return pathMatch[1];
  const q = new URLSearchParams(window.location.search).get('s');
  if (q) return q;
  return null;
}

const sessionToken = readSessionToken() ?? 'mock-session';

const initialState = {
  screen: 'intro',
  sessionToken,
  photos: {
    modem: null,      // { recognized, extraction?, reason?, photoId, room }
    gateway: null,
    aps: [],          // committed, recognized APs only
    pendingAp: null,  // most recent AP upload awaiting user commit/retake
  },
  uploading: false,
  error: null,
};

const actions = {
  async submitPhoto({ slot, file, room }) {
    const current = router.getState();
    router.setState({ uploading: true, error: null });
    try {
      const result = await uploadPhoto({
        sessionToken: current.sessionToken,
        slot,
        file,
        room,
      });
      router.setState((s) => applyUpload(s, { slot, room, result }));
    } catch (err) {
      console.error('[field-trip] upload failed', err);
      router.setState({ error: copy.uploadError });
    } finally {
      router.setState({ uploading: false });
    }
  },
  clearError() {
    router.setState({ error: null });
  },
  clearSlot(slot) {
    router.setState((s) => {
      const next = { ...s, photos: { ...s.photos } };
      if (slot === 'modem' || slot === 'gateway') next.photos[slot] = null;
      if (slot === 'ap') next.photos.pendingAp = null;
      return next;
    });
  },
  commitPendingAp() {
    router.setState((s) => {
      const pending = s.photos.pendingAp;
      if (!pending || !pending.recognized) return s;
      return {
        ...s,
        photos: {
          ...s.photos,
          aps: [...s.photos.aps, pending],
          pendingAp: null,
        },
      };
    });
  },
};

function applyUpload(state, { slot, room, result }) {
  const next = { ...state, photos: { ...state.photos } };
  const record = { ...result, room: room ?? null };
  if (slot === 'modem' || slot === 'gateway') {
    next.photos[slot] = record;
  } else if (slot === 'ap') {
    next.photos.pendingAp = record;
  }
  return next;
}

const router = createRouter({ root, initialState, actions });
router.render();

// Expose for debugging from the phone's web inspector.
if (typeof window !== 'undefined') {
  window.__fieldTrip = { router, actions, SCREENS };
}
